function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from "vue";
/**
 * Create a new Vue Component with props outside Vue.
 *
 * @note https://css-tricks.com/creating-vue-js-component-instances-programmatically/
 *
 * @param {Element} target
 * @param {Type} klass
 * @param {Object} props
 * @param {Object} attrs
 *
 * @returns {import("vue").VueConstructor}
 *
 * @example
 *   newComponent(
 *     document.getElementById("my_button"),   // The target that we will replace the component with
 *     SeatSelector,                           // The component type we want to use
 *     { my_prop: true }                       // The component props
 *     { }                                     // Extended attributes on the component
 *   );
 *
 */

export function newComponent(target, klass) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var attrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ComponentClass = Vue.extend(klass);
  var instance = new ComponentClass(_objectSpread({
    propsData: props
  }, attrs));
  instance.$mount();
  target.appendChild(instance.$el);
  return instance;
}